import { lazy } from 'react';
import { authRoles } from 'app/auth';

import { ClinicProvider } from './ClinicContext';

import OrderListLayout from './layouts/OrderListLayout';
import OrderDetailsLayout from './layouts/OrderDetailsLayout';

const OrderListPage = lazy(() => import('./pages/OrderList'));
const OrderListMessages = lazy(() => import('./pages/OrdersUnreadMessagesList'));
const OrderRequestPage = lazy(() => import('./pages/OrderRequest'));
const ESignaturesPage = lazy(() => import('./pages/ESignatures/ESignatures'));
const OrderMessages = lazy(() => import('./pages/OrderMessages'));

const PrescribingConfig = {
  settings: {
    layout: {
      config: {
        topBanner: {
          display: false,
        },
        footer: {
          display: false,
        },
        healtheraHeader: {
          display: false,
        },
      },
    },
  },
  auth: authRoles.prescriberAndSupport,
  routes: [
    {
      path: 'prescribing',
      element: (
        <ClinicProvider>
          <OrderListLayout>
            <OrderListPage />
          </OrderListLayout>
        </ClinicProvider>
      ),
    },
    {
      path: 'prescribing/new-messages',
      element: (
        <ClinicProvider>
          <OrderListLayout>
            <OrderListMessages />
          </OrderListLayout>
        </ClinicProvider>
      ),
      auth: authRoles.prescriber,
    },
    {
      path: 'prescribing/:orderId',
      element: (
        <ClinicProvider>
          <OrderDetailsLayout>
            <OrderRequestPage />
          </OrderDetailsLayout>
        </ClinicProvider>
      ),
      auth: authRoles.prescriber,
    },
    {
      path: 'prescribing/:orderId/messages',
      element: (
        <ClinicProvider>
          <OrderDetailsLayout>
            <OrderMessages />
          </OrderDetailsLayout>
        </ClinicProvider>
      ),
      auth: authRoles.prescriber,
    },
    {
      path: 'prescribing/e-signatures',
      element: (
        <ClinicProvider>
          <ESignaturesPage />
        </ClinicProvider>
      ),
      auth: authRoles.prescriber,
    },
  ],
};

export default PrescribingConfig;
